import memoizee from 'memoizee';

import {metaData, osm, userGeolocation} from '@mapsight/ui/config/map-layers';
import {
	interactiveFeatures as baseInteractiveFeatures,
	features as baseFeatures
} from '@mapsight/ui/src/js/config/map/layers';

import {navPosition} from '../routing/nav-pos';
import {KINDER_POI_URI} from './feature-sources';

// TODO check if the default fit for Stade
const defaultFitFeaturesInViewOptions = {
	duration: 700, // default: 300
	padding: [20, 20, 20, 20], // default: [60, 100, 60, 100]
	keepZoom: false, // default: false
	nearest: true, // default: false
	maxZoom: 19, // default: 17
	skipIfInView: false, // default: true
};

const osmAttributionDe =
	'Karte: © <a class="stade-link stade-link--external" href="https://www.openstreetmap.org/copyright" rel="external">OpenStreetMap-Mitwirkende</a>, ' +
	'App: © <a class="stade-link stade-link--external" href="https://neonaut.de" rel="external">neonaut.de</a>.';
const osmAttributionEn =
	'Map: © <a class="stade-link stade-link--external" href="https://www.openstreetmap.org/copyright" rel="external">OpenStreetMap contributors</a>, ' +
	'App: © <a class="stade-link stade-link--external" href="https://neonaut.de" rel="external">neonaut.de</a>.';

const LAYER_SWITCHER_GROUP='Karten-Ebenen';


// TODO: Maybe make these defaults configurable in @mapsight/ui?
function interactiveFeatures(featureSourceId, visible, _metaData, style, sourceOptions = {}) {
	return baseInteractiveFeatures(featureSourceId, visible, _metaData, style, {
		...sourceOptions,
		//centerFeaturesInViewSelections: ['select'], // default: []
		//centerFeaturesInViewOptions: {
		//	duration: 300, // default: 300
		//	zoom: 14, // default: undefined
		//	...sourceOptions.centerFeaturesInViewOptions,
		//},
		fitFeaturesInViewSelections: ['preselect', 'select'], // default: ['select']
		fitFeaturesInViewOptions: {
			...defaultFitFeaturesInViewOptions,
			...sourceOptions.fitFeaturesInViewOptions,
		},
	});
}
function nonInteractiveFeatures(featureSourceId, visible, _metaData, style, sourceOptions = {}) {
	return baseFeatures(featureSourceId, visible, false, _metaData, style, {
		...sourceOptions,
		//centerFeaturesInViewSelections: ['select'], // default: []
		//centerFeaturesInViewOptions: {
		//	duration: 300, // default: 300
		//	zoom: 14, // default: undefined
		//	...sourceOptions.centerFeaturesInViewOptions,
		//},
		//fitFeaturesInViewSelections: ['select'], // default: ['select']
		fitFeaturesInViewOptions: {
			...defaultFitFeaturesInViewOptions,
			...sourceOptions.fitFeaturesInViewOptions,
		},
	});
}

const topicFeature = (uri, name, visible, visibleInLayerSwitcher, isBaseLayer) => {
	const metaDataValue = metaData(name, '', visibleInLayerSwitcher, false, isBaseLayer, LAYER_SWITCHER_GROUP, isBaseLayer);
	return interactiveFeatures(
		uri,
		visible,
		metaDataValue,
		'features'
	);
};


export default memoizee(function configMapLayers(magic, locPathname, locState) {
	const navPos = locPathname ? navPosition(magic, locPathname, locState) : {};

	const result = {
		vmz: osm(`${navPos.app?.url}/tiles/none/{z}/{x}/{y}.png`, true,
					metaData('Grundkarte', navPos?.app?.lang === 'en' ? osmAttributionEn : osmAttributionDe, true, false, true, LAYER_SWITCHER_GROUP, true)
		),
		userGeolocation: userGeolocation('userGeolocation', true, metaData('Benutzerstandort')),
		// searchResult: interactiveFeatures('searchResult', false, metaData('Suchergebnis')),
	};

	if(navPos.app) {
		result[`${navPos.app.uri}-route`] = nonInteractiveFeatures(`${navPos.app.uri}-route`, 'Route', metaData('Route', null, false, false, true));

		if(navPos.app.uri === 'kinder-de') {
			result[KINDER_POI_URI] = topicFeature(KINDER_POI_URI, `${navPos.app.title} POI`, true, false, true);
		}

		result[navPos.app.uri] = topicFeature(navPos.app.uri, navPos.app.title, true, false, true);
	}

	if (process.env.NN_JS_LOG_LEVEL === 'verbose') {
		console.log('mapLayers', {result, navPos, locPathname, magic});
	}
	return result;
});
